import './PrivacyPolicy.css';

function PrivacyPolicy() {
    return (
        <div className='privacy-policy-container'>
            <h1 className='privacy-policy-title'>Informativa sulla Privacy</h1>

            <p>
                Ai sensi degli artt. 13 e 14 del Regolamento (UE) 2016/679 ("GDPR") e del D.Lgs. 196/2003
                (Codice in materia di protezione dei dati personali), come modificato dal D.Lgs. 101/2018,
                l'Associazione Settemotivi ODV fornisce le seguenti informazioni relative al trattamento dei
                dati personali degli utenti che consultano questo sito web.
            </p>

            <h2>Titolare del trattamento</h2>
            <p>
                Associazione Settemotivi ODV – Via De Paoli n. 19 – 33170 Pordenone (PN) – C.F. 91100000933<br />
                Email: <a href="mailto:segreteria@settemotivi.it">segreteria@settemotivi.it</a><br />
                PEC: <a href="mailto:settemotivi@pec.csvfvg.it">settemotivi@pec.csvfvg.it</a>
            </p>

            <h2>Tipologia di dati raccolti</h2>
            <p>
                Il sito raccoglie unicamente i dati personali che l'utente fornisce volontariamente
                contattando l'Associazione (ad esempio nome, cognome, indirizzo email e contenuto del
                messaggio inviato via email o telefono). Il sito non utilizza form di raccolta dati
                automatizzati né richiede la creazione di account utente.
            </p>
            <p>
                Per le donazioni, il sito indica gli estremi del conto corrente dell'Associazione per
                l'esecuzione di un bonifico bancario: nessun dato di pagamento (es. carta di credito)
                viene raccolto o trattato direttamente dal sito.
            </p>

            <h2>Finalità e base giuridica del trattamento</h2>
            <ul>
                <li>Rispondere alle richieste di informazioni o collaborazione inviate dagli utenti (base giuridica: consenso dell'interessato / misure precontrattuali);</li>
                <li>Gestire i rapporti con soci, volontari e donatori dell'Associazione (base giuridica: esecuzione del rapporto associativo o della donazione);</li>
                <li>Adempiere agli obblighi di legge, inclusi quelli di trasparenza previsti dalla L. 124/2017 per gli enti che ricevono contributi pubblici (base giuridica: obbligo legale).</li>
            </ul>

            <h2>Modalità del trattamento e conservazione</h2>
            <p>
                I dati sono trattati con strumenti informatici e/o cartacei, con logiche strettamente
                correlate alle finalità sopra indicate e con l'adozione di misure di sicurezza adeguate a
                prevenirne la perdita, l'uso illecito o non corretto e l'accesso non autorizzato. I dati
                sono conservati per il tempo necessario al conseguimento delle finalità per cui sono stati
                raccolti, salvi i maggiori termini previsti dalla legge.
            </p>

            <h2>Comunicazione e diffusione dei dati</h2>
            <p>
                I dati personali non vengono diffusi né comunicati a terzi, salvo che l'invio a soggetti
                terzi sia necessario per adempiere a un obbligo di legge o a una richiesta dell'autorità
                competente.
            </p>

            <h2>Diritti dell'interessato</h2>
            <p>
                In qualsiasi momento è possibile esercitare i diritti previsti dagli artt. 15-22 del GDPR
                (accesso, rettifica, cancellazione, limitazione del trattamento, portabilità dei dati,
                opposizione) scrivendo a{' '}
                <a href="mailto:segreteria@settemotivi.it">segreteria@settemotivi.it</a>. È inoltre
                possibile proporre reclamo all'Autorità Garante per la protezione dei dati personali
                (www.garanteprivacy.it) qualora si ritenga che il trattamento violi la normativa vigente.
            </p>

            <h2>Cookie</h2>
            <p>
                Per informazioni sui cookie utilizzati da questo sito si rimanda alla{' '}
                <a href="/cookie-policy">Cookie Policy</a>.
            </p>
        </div>
    );
}

export default PrivacyPolicy;
